import Theme from 'components/common/Theme/Theme'

const defaultOptions = {
  closeBoxURL: '',
  alignBottom: true,
  boxStyle: {
    backgroundColor: Theme.colors.white,
    padding: '10px',
    borderRadius: '2px',
    overflow: 'visible',
    boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.5)'
  }
}

export default defaultOptions
